import { gql } from "@apollo/client";

const CREATE_CAPA = gql`
    mutation createGestionCapa($input: AddGestionCapaInput!, $archivos: [ArchivoCapaInput!] ){
        createGestionCapa(input: $input, archivos: $archivos) {
            idGestionCapa
        }
    }
`;

export default CREATE_CAPA;